export const baseUrl = "https://argo-backend-api.herokuapp.com";

// export const baseUrl = "http://localhost:3001";

export const apiPath = baseUrl;
